import React from 'react';
import PropTypes from 'prop-types';

const serialize = require('serialize-javascript');

const { Script } = require('nordic/script');

const { createSchemaData } = require('./decorators');

const VehicleSchema = (props) => {
  const { value } = props;
  const schemaData = createSchemaData(value);

  return (
    <Script type="application/ld+json">
      {serialize(schemaData, { isJSON: true })}
    </Script>
  );
};

VehicleSchema.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string.isRequired,
    brand_name: PropTypes.string.isRequired,
    model_name: PropTypes.string.isRequired,
    year_name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    availability: PropTypes.string.isRequired,
    image_url: PropTypes.string.isRequired,
    technical_info: PropTypes.shape({
      pricing_info: PropTypes.shape({
        price: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
        min_price: PropTypes.number.isRequired,
        max_price: PropTypes.number.isRequired,
      }),
      body_type: PropTypes.string.isRequired,
      fuel_type: PropTypes.string.isRequired,
      configuration: PropTypes.string.isRequired,
      transmission: PropTypes.string.isRequired,
      vehicle_engine: PropTypes.shape({
        engine_type: PropTypes.string.isRequired,
        engine_power: PropTypes.shape({
          unit: PropTypes.string.isRequired,
          value: PropTypes.number.isRequired,
        }),
        engine_displacement: PropTypes.shape({
          unit: PropTypes.string.isRequired,
          value: PropTypes.number.isRequired,
        }),
      }),
      width: PropTypes.shape({
        unit: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
      }),
      height: PropTypes.shape({
        unit: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
      }),
    }),
  }).isRequired,
};

export default VehicleSchema;
